<template>
  <el-dialog
    title="编辑进路"
    :visible.sync="innerVisible"
    width="760px"
    top="6vh"
    @opened="onOpened"
    @close="onClose"
  >
    <div class="path-tab-nav-row">
      <el-tabs v-model="pathActiveTab" type="card" class="path-sub-tabs">
        <el-tab-pane
          v-for="item in pathList"
          :key="'path-' + item.pathOrder"
          :label="'进路' + item.pathOrder"
          :name="String(item.pathOrder)"
        />
      </el-tabs>
      <el-button size="small" type="primary" icon="el-icon-plus" class="path-tab-add" @click="addPath">新增进路</el-button>
      <el-button v-if="pathList.length > 1" size="small" type="danger" icon="el-icon-delete" class="path-tab-del" @click="removeCurrentPath">删除当前进路</el-button>
    </div>
    <div class="path-tab-body">
      <case-path-form
        v-if="currentPathItem"
        :path="currentPathItem.path"
        :ext="currentPathItem.ext"
        :edu-list="eduList"
        :path-direction-list="pathDirectionList"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submiting" @click="saveAll">保存</el-button>
      <el-button @click="innerVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import caseOptions from "@/plugins/caseOptions.js";
import CasePathForm from "@/components/StudentCasePathForm.vue";

const emptyPath = () => ({
  pathDirection: "", eduBack: "", artsScience: "", enrollSchool: "", enrollMajor: "",
  eligibilityTime: "", incomeDate: "", japaneseScore: "",
  englishType: "", englishScore: null, internalExam: "", examExperience: ""
});

const emptyPathExt = () => ({
  ejuScore: "", researchDept: "", specialization: "", enrollMethod: "",
  jobStartTime: "", companyType: "", companyScale: "", industry: "",
  position: "", annualSalary: "", jobPath: "", jobExperience: "",
  returnReason: "", otherRemark: ""
});

export default {
  name: "StudentPathDialog",
  components: { CasePathForm },
  props: {
    visible: { type: Boolean, default: false },
    stuID: { type: Number, default: 0 },
    visitID: { type: Number, default: 0 },
    visitSubject: { type: String, default: "" },
    visitNoticeDate: { type: String, default: "" }
  },
  data() {
    return {
      innerVisible: false,
      pathActiveTab: "1",
      pathList: [{ pathOrder: 1, path: emptyPath(), ext: emptyPathExt() }],
      submiting: false,
      eduList: caseOptions.eduList,
      pathDirectionList: caseOptions.pathDirectionList
    };
  },
  computed: {
    currentPathItem() {
      var order = parseInt(this.pathActiveTab, 10);
      return this.pathList.find(function(p) { return p.pathOrder === order; }) || this.pathList[0];
    }
  },
  watch: {
    visible(val) {
      this.innerVisible = val;
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  methods: {
    onClose() {
      this.pathList = [{ pathOrder: 1, path: emptyPath(), ext: emptyPathExt() }];
      this.pathActiveTab = "1";
    },
    onOpened() {
      this.loadPaths();
    },
    loadPaths() {
      if (!this.stuID) return;
      var _this = this;
      $.get(url.getStu("getcase"), { stuID: this.stuID }, function(data) {
        _this.loadPathsFromServer(data && data.paths);
      });
    },
    loadPathsFromServer(paths) {
      if (!paths || !paths.length) {
        this.pathList = [{ pathOrder: 1, path: emptyPath(), ext: emptyPathExt() }];
        this.pathActiveTab = "1";
        return;
      }
      var _this = this;
      this.pathList = paths.map(function(row) {
        return _this.rowToPathItem(row);
      }).sort(function(a, b) { return a.pathOrder - b.pathOrder; });
      this.pathActiveTab = String(this.pathList[0].pathOrder);
    },
    rowToPathItem(row) {
      var ex = row.ext || {};
      return {
        pathOrder: row.pathOrder || 1,
        path: {
          pathDirection: row.pathDirection || "",
          eduBack: row.eduBack || "",
          artsScience: row.artsScience || "",
          enrollSchool: row.enrollSchool || "",
          enrollMajor: row.enrollMajor || "",
          eligibilityTime: row.eligibilityTime || "",
          incomeDate: row.incomeDate || "",
          japaneseScore: row.japaneseScore || "",
          englishType: row.englishType || "",
          englishScore: row.englishScore != null ? row.englishScore : null,
          internalExam: row.internalExam || "",
          examExperience: row.examExperience || ""
        },
        ext: Object.assign(emptyPathExt(), ex)
      };
    },
    addPath() {
      var maxOrder = 0;
      this.pathList.forEach(function(p) {
        if (p.pathOrder > maxOrder) maxOrder = p.pathOrder;
      });
      var newOrder = maxOrder + 1;
      this.pathList.push({ pathOrder: newOrder, path: emptyPath(), ext: emptyPathExt() });
      this.pathActiveTab = String(newOrder);
    },
    removeCurrentPath() {
      var _this = this;
      if (this.pathList.length <= 1) return;
      var item = this.currentPathItem;
      if (!item) return;
      this.$confirm("确定删除进路" + item.pathOrder + "？", "提示", { type: "warning" }).then(function() {
        $.post(url.getStu("deletecase_path"), { stuID: _this.stuID, pathOrder: item.pathOrder }).always(function() {
          var idx = _this.pathList.findIndex(function(p) { return p.pathOrder === item.pathOrder; });
          if (idx >= 0) _this.pathList.splice(idx, 1);
          _this.pathActiveTab = String(_this.pathList[0].pathOrder);
          _this.$message.success("已删除");
        });
      }).catch(function() {});
    },
    savePathItem(item) {
      var _this = this;
      var p = item.path;
      var e = item.ext;
      if (!p.pathDirection) return $.when();
      var data = {
        "path.stuID": _this.stuID,
        "path.pathOrder": item.pathOrder,
        "path.pathDirection": p.pathDirection,
        "path.eduBack": p.eduBack,
        "path.artsScience": p.artsScience,
        "path.enrollSchool": p.enrollSchool,
        "path.enrollMajor": p.enrollMajor,
        "path.eligibilityTime": p.eligibilityTime,
        "path.incomeDate": p.incomeDate,
        "path.japaneseScore": p.japaneseScore,
        "path.englishType": p.englishType,
        "path.englishScore": p.englishScore,
        "path.internalExam": p.internalExam,
        "path.examExperience": p.examExperience,
        "ext.ejuScore": e.ejuScore,
        "ext.researchDept": e.researchDept,
        "ext.specialization": e.specialization,
        "ext.enrollMethod": e.enrollMethod,
        "ext.jobStartTime": e.jobStartTime,
        "ext.companyType": e.companyType,
        "ext.companyScale": e.companyScale,
        "ext.industry": e.industry,
        "ext.position": e.position,
        "ext.annualSalary": e.annualSalary,
        "ext.jobPath": e.jobPath,
        "ext.jobExperience": e.jobExperience,
        "ext.returnReason": e.returnReason,
        "ext.otherRemark": e.otherRemark
      };
      return $.post(url.getStu("savecase_path"), data).then(function(res) {
        if (res && res.status === false) {
          return $.Deferred().reject(res).promise();
        }
      });
    },
    markVisitDone() {
      if (!this.visitID || !this.stuID) return $.when();
      return $.post(url.getStu("addorupdate_visit_simple"), {
        id: this.visitID,
        stuid: this.stuID,
        summary: "",
        subject: this.visitSubject || "",
        noticeDate: this.visitNoticeDate || null
      });
    },
    saveAll() {
      var _this = this;
      var hasDirection = false;
      this.pathList.forEach(function(item) {
        if (item.path.pathDirection) hasDirection = true;
      });
      if (!hasDirection) {
        this.$message.warning("请选择进路方向");
        return;
      }
      _this.submiting = true;
      var chain = $.when();
      this.pathList.forEach(function(item) {
        chain = chain.then(function() { return _this.savePathItem(item); });
      });
      chain
        .then(function() { return _this.markVisitDone(); })
        .done(function() {
          _this.submiting = false;
          _this.$message.success("保存成功");
          _this.innerVisible = false;
          _this.$emit("saved");
        })
        .fail(function(xhr) {
          _this.submiting = false;
          var msg = (xhr && xhr.msg) || (xhr.responseJSON && xhr.responseJSON.msg) || "保存失败";
          _this.$message.error(msg);
        });
    }
  }
};
</script>

<style scoped>
.path-tab-nav-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.path-sub-tabs {
  flex: 0 1 auto;
  max-width: calc(100% - 220px);
}
.path-sub-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}
.path-sub-tabs >>> .el-tabs__content {
  display: none;
}
.path-tab-add {
  flex-shrink: 0;
  margin: 4px 0 0 4px;
}
.path-tab-del {
  flex-shrink: 0;
  margin: 4px 0 0 8px;
}
.path-tab-body {
  margin-top: 16px;
  padding: 0 8px;
  max-height: 58vh;
  overflow-y: auto;
}
</style>
